// extracted by mini-css-extract-plugin
export default {"swatch":"swatch__LlYMS","default":"default__KATZP","active":"active__UsV_N","md":"md__iJLgG default__KATZP","sm":"sm__Odj32 default__KATZP","has-gradient":"has-gradient__LXLdW"};